import FloatingTextArea from './FloatingTextArea'

export default FloatingTextArea
